import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const Customers = () => import(/* webpackChunkName: "sipcentric" */'@/views/sipcentric/Customers')
const Customer = () => import(/* webpackChunkName: "sipcentric" */'@/views/sipcentric/customer/Customer')

const ManagePbx = () => import(/* webpackChunkName: "sipcentric" */'@/views/sipcentric/customer/ManagePbx')
const ProvisionPbx = () => import(/* webpackChunkName: "sipcentric" */'@/views/sipcentric/customer/ProvisionPbx')
const DisablePbx = () => import(/* webpackChunkName: "sipcentric" */'@/views/sipcentric/customer/DisablePbx')

function props (route) {
    return {
        customerId: parseInt(route.params.customerId)
    }
}

export default {
    path: '/sipcentric/customers',
    alias: '/sipcentric',
    name: routeNames.CUSTOMERS,
    meta: {title: 'Customers'},
    component: Customers,
    children: [
        {
            path: 'create',
            name: routeNames.CREATE_CUSTOMER_PBX,
            meta: {title: 'Create PBX'},
            component: ManagePbx
        },
        {
            path: ':customerId',
            component: BaseRouterView,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CUSTOMER,
                    props,
                    meta: {title: 'Customer Details'},
                    component: Customer
                },
                {
                    path: 'update',
                    name: routeNames.UPDATE_CUSTOMER_PBX,
                    props,
                    meta: {title: 'Update PBX'},
                    component: ManagePbx
                },
                {
                    path: 'provision',
                    name: routeNames.PROVISION_CUSTOMER_PBX,
                    props,
                    meta: {title: 'Provision PBX'},
                    component: ProvisionPbx
                },
                {
                    path: 'disable',
                    name: routeNames.DISABLE_PBX,
                    props,
                    meta: {title: 'Disable PBX'},
                    component: DisablePbx
                }
            ]
        }
    ]
}
